"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Popover_logic_1 = require("./Popover.logic");
var Popover_style_1 = __importDefault(require("./Popover.style"));
/**
 * Popover atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-popover--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Popover Source}
 */
var Popover = function (_a) {
    var anchorElement = _a.anchorElement, closePopover = _a.closePopover, _b = _a.withTriangleTip, withTriangleTip = _b === void 0 ? false : _b, _c = _a.canAppearOutOfWindow, canAppearOutOfWindow = _c === void 0 ? true : _c, _d = _a.popoverPosition, popoverPosition = _d === void 0 ? 'top' : _d, popoverOffset = _a.popoverOffset, _e = _a.disableRestoreFocus, disableRestoreFocus = _e === void 0 ? false : _e, _f = _a.disableEnforceFocus, disableEnforceFocus = _f === void 0 ? false : _f, overflow = _a.overflow, children = _a.children, stopPropagation = _a.stopPropagation;
    var classes = (0, Popover_style_1.default)();
    var trianglePositionClassNames = (0, classnames_1.default)(popoverPosition === 'left' && classes.triangleTipRight, popoverPosition === 'top' && classes.triangleTipBottom, popoverPosition === 'right' && classes.triangleTipLeft, popoverPosition.includes('bottom') && classes.triangleTipTop);
    var _g = (0, Popover_logic_1.usePopoverAlignment)(popoverPosition, popoverOffset), horizontalAnchorOrigin = _g.horizontalAnchorOrigin, horizontalTransformOrigin = _g.horizontalTransformOrigin, styleOverrides = _g.styleOverrides, verticalAnchorOrigin = _g.verticalAnchorOrigin, verticalTransformOrigin = _g.verticalTransformOrigin;
    return ((0, jsx_runtime_1.jsx)(core_1.Popover, __assign({ open: !!anchorElement, anchorEl: anchorElement, onClose: closePopover, anchorOrigin: {
            vertical: verticalAnchorOrigin,
            horizontal: horizontalAnchorOrigin,
        }, transformOrigin: {
            vertical: verticalTransformOrigin,
            horizontal: horizontalTransformOrigin,
        }, marginThreshold: canAppearOutOfWindow ? -theme_1.default.topbarHeight : undefined, classes: {
            paper: (0, classnames_1.default)(classes.root, overflow === 'hidden' && classes.overflowHidden, overflow === 'auto' && classes.overflowAuto, withTriangleTip && classes.triangleTip, trianglePositionClassNames),
        }, style: styleOverrides, disableRestoreFocus: disableRestoreFocus, disableEnforceFocus: disableEnforceFocus, onClick: stopPropagation ? function (event) { return event.stopPropagation(); } : undefined }, { children: children })));
};
exports.Popover = Popover;
